package com.milta.feature.aicredit.data.repository

import com.milta.core.network.PagedResult
import com.milta.feature.aicredit.data.remote.AiCreditApi
import com.milta.feature.aicredit.data.remote.dto.toDomain
import com.milta.feature.aicredit.data.remote.dto.toDto
import com.milta.feature.aicredit.domain.entity.AdminAccountAiCredit
import com.milta.feature.aicredit.domain.entity.AdminAiCredit
import com.milta.feature.aicredit.domain.entity.AdminAiCreditHistoryEntry
import com.milta.feature.aicredit.domain.entity.AiCredit
import com.milta.feature.aicredit.domain.entity.AiCreditHistoryEntry
import com.milta.feature.aicredit.domain.entity.AiCreditSettings
import com.milta.feature.aicredit.domain.repository.AiCreditRepository
import com.milta.feature.route.data.remote.dto.toDomain

// No offline fallback, as for the MIL-97 counter: a cached credit would show an AI action as
// available when it is not.
class AiCreditRepositoryImpl(private val api: AiCreditApi) : AiCreditRepository {
    override suspend fun getMyCredit(): Result<AiCredit> = runCatching { api.getMyCredit().toDomain() }

    override suspend fun getMyHistory(page: Int, pageSize: Int): Result<PagedResult<AiCreditHistoryEntry>> =
        runCatching { api.getMyHistory(page, pageSize).toDomain { it.toDomain() } }

    override suspend fun getSettings(): Result<AiCreditSettings> = runCatching { api.getSettings().toDomain() }

    override suspend fun updateSettings(settings: AiCreditSettings): Result<AiCreditSettings> =
        runCatching { api.updateSettings(settings.toDto()).toDomain() }

    override suspend fun getAccountCredit(accountId: String): Result<AdminAccountAiCredit> =
        runCatching { api.getAccountCredit(accountId).toDomain() }

    override suspend fun getAccountHistory(
        accountId: String,
        page: Int,
        pageSize: Int,
    ): Result<PagedResult<AdminAiCreditHistoryEntry>> =
        runCatching { api.getAccountHistory(accountId, page, pageSize).toDomain { it.toDomain() } }

    override suspend fun replaceRemaining(accountId: String, remainingEur: Double): Result<AdminAiCredit> =
        runCatching { api.replaceRemaining(accountId, remainingEur).toDomain() }
}
